import React, { Component } from "react";

const DoneIcon = ({ fill, fill_2, ...rest }) => {
  return (
    <svg
      width="129"
      height="128"
      viewBox="0 0 129 128"
      fill="none"
      {...rest}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M128.473 8.69269C107.695 2.72127 86.1605 -0.203122 64.5426 0.0109554C42.9247 -0.203122 21.3902 2.72127 0.612305 8.69269L0.612305 119.205C21.3902 125.176 42.9247 128.101 64.5426 127.887C86.1605 128.101 107.695 125.176 128.473 119.205V8.69269Z"
        fill={fill}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M60.174 77.8939L83.2954 54.7725L78.5218 50.0046L60.174 68.3524L49.8972 58.4432L45.1236 63.2168L60.174 77.8939ZM63.4771 30.1863C70.0099 30.1863 76.396 32.1235 81.8279 35.753C87.2597 39.3824 91.4933 44.5411 93.9933 50.5766C96.4933 56.6122 97.1474 63.2535 95.8729 69.6608C94.5984 76.0681 91.4526 81.9535 86.8332 86.5729C82.2138 91.1923 76.3283 94.3382 69.921 95.6127C63.5137 96.8872 56.8724 96.2331 50.8369 93.7331C44.8013 91.2331 39.6427 86.9995 36.0132 81.5676C32.3838 76.1358 30.4466 69.7497 30.4466 63.2168C30.4283 58.8741 31.2702 54.5707 32.9237 50.5551C34.5772 46.5394 37.0095 42.8909 40.0803 39.8201C43.1511 36.7493 46.7996 34.3169 50.8153 32.6635C54.831 31.01 59.1344 30.1681 63.4771 30.1863Z"
        fill={fill_2}
      />
    </svg>
  );
};

DoneIcon.defaultProps = {
  fill: "#E31C79",
  fill_2: "white",
};

export default DoneIcon;
